module.exports = __webpack_public_path__ + "static/Varun.dd4f561f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Varun.jpg
// module id = 1329
// module chunks = 137408898365125